<template>
  <div class="smart smart-markdown" tabindex="0" @focus="$refs.textarea.focus()">
    <div class="editor">
        <textarea ref="textarea" :value="value" @input="onInput" @change="onChange" @keydown="$emit('keydown',$event)" :maxlength="maxlength"></textarea>
        <div v-html="compiledMarkdown"></div>
    </div>
  </div>
</template>

<script>
var marked = require('marked');
var _ = require('lodash');
export default {
  name: 'SmartMarkdown',
  props:{
    value:{
        type: String
    },
    maxlength:{
      type: Number
    }
  },
  computed: {
    compiledMarkdown: function () {
      return marked(this.value || '', { sanitize: true })
    }
  },
  methods: {
    onInput: _.debounce(function (e) {
      this.$emit('input', e.target.value);
    }, 300),
    onChange(event){
      this.$emit('change',event.target.value)
    }
  }
}
</script>

<style>
.smart-markdown .editor{
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-flow: column;
  grid-column-gap: 8px;
}

.xs .smart-markdown .editor{
  grid-template-columns: 1fr;
  grid-auto-flow: row;
}

.smart-markdown textarea{
    resize: none;
    font-family: monospace;
}

.smart-markdown .editor *{
    margin: 4px 0;
}

.smart-markdown .editor ul{
    list-style-type: square;
}

.smart-markdown .editor a, .smart-markdown pre{
    color: var(--foreground);
    background: var(--control-background-light);
    font-style: normal;
    cursor: pointer;
    padding: 2px;
}
</style>